import React, { useEffect, useState } from "react";
import { Row, Col, Tree, Spin } from "antd";
import { useTranslation } from "react-i18next";
import axios from "axios";
import AuthenticatedLayout from "../../layouts/authenticated";
import FlexCard from "../../components/flex-card";
import useFormatter from "../../hooks/useFormatter";
import unwrapAxiosPromise from "../../util/unwrapAxiosPromise";
import BreadcrumbTitulo from "@/components/breadcrumb-titulo";

export default function ArmazenamentoEmUsoPage() {
  const [loading, setLoading] = useState(true);
  const [treeData, setTreeData] = useState([]);
  const { formatBytes } = useFormatter();
  const { t } = useTranslation();

  useEffect(() => {
    unwrapAxiosPromise(axios.get("/armazenamento-em-uso"))
      .then((data) => {
        setTreeData([data].map(mapTreeNode));
      })
      .finally(() => setLoading(false));
  }, []);

  return (
    <AuthenticatedLayout breadcrumb={[t("Armazenamento em Uso")]}>
      <FlexCard title={<BreadcrumbTitulo selected={t("Armazenamento em Uso")} />} headStyle={{ backgroundColor: "#f0f0f06b" }}>
        {loading ? (
          <Spin />
        ) : (
          <Tree
            defaultExpandedKeys={["Total"]}
            autoExpandParent
            showIcon
            showLine={{ showLeafIcon: false }}
            titleRender={({ data }) => (
              <Row gutter={[8, 8]}>
                <Col>{data.name.replace(/\[\d+\]/g, "")}</Col>
                <Col>
                  <small>({formatBytes(data.size)})</small>
                </Col>
                <Col>
                  <small>({data.extra})</small>
                </Col>
              </Row>
            )}
            treeData={treeData}
          />
        )}
      </FlexCard>
    </AuthenticatedLayout>
  );
}

function mapTreeNode(row) {
  return {
    children: row.children?.map(mapTreeNode),
    data: row,
    key: row.path,
    title: row.name,
  };
}
